import { HeatingUpdateLayout } from './HeatingUpdate.layout';
import { HeatingDeficiencyLayout } from './HeatingDeficiency.layout';

export class HeatingSystemLayout {
	public fields = [
		{ fieldName: 'uniformHeatingIndicator', label: 'Indicator' },
		{ fieldName: 'heatingType', label: 'Type' },
		{ fieldName: 'heatingFuelType', label: 'Fuel Type' },
		{ fieldName: 'cv_heatingFuelDescription', label: 'Fuel Description' }
	];

	public fieldsArray = [
		{
			fieldName: 'HeatingUpdates',
			label: 'Heating Updates',
			fields: new HeatingUpdateLayout().fields
		},
		{
			fieldName: 'HeatingDeficiencies',
			label: 'Heating Deficiencies',
			fields: new HeatingDeficiencyLayout().fields
		}
	];
}
